import { render, staticRenderFns } from "./RuleCoefficient.vue?vue&type=template&id=adabd4d6"
import script from "./RuleCoefficient.vue?vue&type=script&lang=js"
export * from "./RuleCoefficient.vue?vue&type=script&lang=js"
import style0 from "./RuleCoefficient.vue?vue&type=style&index=0&id=adabd4d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports